import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
var _require = require('lodash'),
    get = _require.get;

var Customer = /*#__PURE__*/function () {
  function Customer(emailDigest) {
    this._customerId = get(emailDigest, 'userId', 0);
    this._customerName = get(emailDigest, 'userName', 0);
    this._year = get(emailDigest, 'year', 0);
    this._month = get(emailDigest, 'month', 0);
  }
  /** **********************************************
   *  Getters/Setters of raw data
   * ********************************************* */


  _createClass(Customer, [{
    key: 'customerId',
    get: function get() {
      return this._customerId;
    }
  }, {
    key: 'customerName',
    get: function get() {
      return this._customerName;
    }
  }, {
    key: 'year',
    get: function get() {
      return this._year;
    }
  }, {
    key: 'month',
    get: function get() {
      return this._month;
    }
  }]);

  return Customer;
}();

export { Customer as default };